import React from 'react';
import './view.less';

/**
 * @class CnSmartPrimarySub
 * @description 
 */
export default class CnSmartPrimarySub extends React.Component {
  static displayName = 'CnSmartPrimarySub';

  constructor(props) {
    super(props);
  }

  render() {
    return this.props.children;
  }
}
